/**
 * Simulate mouseenter/mouseleave, chromium 28 doesn't support these events yet
 * @param {object} e - mouse event
 * @returns {boolean} true if event is mouseEnter or mouseLeave
 */
function notMouseEvent(e) {
    return !e.forced &&
        e.relatedTarget &&
        (
            e.relatedTarget === e.currentTarget ||
            (e.currentTarget.compareDocumentPosition(e.relatedTarget) & Node.DOCUMENT_POSITION_CONTAINED_BY) // eslint-disable-line no-bitwise
        );
}

export {
    notMouseEvent as notMouseEvent
};
